/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamCurrentQuestion } from './oralExamCurrentQuestion';

export type OralExamRunStateResponseCurrentQuestion = OralExamCurrentQuestion | null;
